<template>
    <vx-table-row>
        <div class="category-handle" :class="props.disabled ? 'pointer-events-none opacity-50' : 'cursor-move'">
            <font-awesome-icon widthAuto :icon="faGripDotsVertical"></font-awesome-icon>
        </div>

        <vx-table-row-title class="min-w-0">
            <div class="flex items-center gap-3">
                <vx-popover v-if="!props.disabled" placement="top" class="shrink-0" arrow>
                    <span
                        class="block size-9 rounded-lg cursor-pointer transition"
                        :style="{ backgroundColor: '#' + category.color }"
                    ></span>
                    <template v-slot:content="{ close }">
                        <div class="flex gap-2">
                            <div
                                v-for="option of THREAD_CATEGORY_COLORS_OPTIONS"
                                :key="option.value"
                                class="cursor-pointer hover:scale-110 active:scale-90 rounded size-10 transition outline outline-2 outline-offset-2"
                                :class="category.color === option.value ? '' : 'outline-transparent'"
                                :style="{
                                    backgroundColor: '#' + option.value,
                                    ...(category.color === option.value ? { outlineColor: '#' + option.value } : {}),
                                }"
                                @click="
                                    close();
                                    category = { ...category, color: option.value };
                                "
                            ></div>
                        </div>
                    </template>
                </vx-popover>
                <span
                    v-else
                    class="block shrink-0 size-9 rounded-lg"
                    :style="{ backgroundColor: '#' + category.color }"
                ></span>

                <span class="min-w-0 truncate">{{ category.name }}</span>
            </div>
            <div v-if="category.description" class="text-sm text-slate-500 font-normal line-clamp-2 mt-1">
                {{ category.description }}
            </div>
        </vx-table-row-title>

        <vx-table-row-item>
            <template v-slot:label>Classification Instructions:</template>
            <div class="text-sm text-slate-500 line-clamp-2">
                {{ category.classification_instructions }}
            </div>
        </vx-table-row-item>

        <vx-table-row-buttons>
            <vx-button
                data-test="delete-btn"
                outline
                color="muted"
                :disabled="props.disabled"
                @click="emit('delete', category)"
            >
                <font-awesome-icon widthAuto :icon="faTrash"></font-awesome-icon>
            </vx-button>
            <vx-button
                data-test="edit-btn"
                outline
                color="muted"
                :disabled="props.disabled"
                @click="emit('edit', category)"
            >
                Edit <font-awesome-icon widthAuto :icon="faFilePen"></font-awesome-icon>
            </vx-button>
        </vx-table-row-buttons>
    </vx-table-row>
</template>

<script lang="ts" setup>
import { faFilePen, faGripDotsVertical, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    VxButton,
    VxPopover,
    VxTableRow,
    VxTableRowButtons,
    VxTableRowItem,
    VxTableRowTitle,
} from '@voxie/frontend-components';
import { THREAD_CATEGORY_COLORS_OPTIONS } from '~/constants/messageHub';
import type { ThreadCategoryType } from '~/services/intelligentInboxSettings/intelligentInboxSettingsClient.types';

const props = defineProps<{
    disabled?: boolean;
}>();

const category = defineModel<ThreadCategoryType>({
    required: true,
});

const emit = defineEmits<{
    edit: [category: ThreadCategoryType];
    delete: [category: ThreadCategoryType];
}>();
</script>
